import React, { useEffect, useState } from 'react';
import { PageTitle, PseudoStates } from '@cordata/buffet';
import { useParams } from 'react-router-dom';
import { deburrObject } from '~/utils/api/normalizers';
import { authorizedInstance as Rb } from '~/utils';

import { Form } from '~/components/Doc';
import { AttachmentProvider } from '~/utils/attachment';

const PatientsDocsDetails = () => {
  const params = useParams();
  const [status, setStatus] = useState('loading');
  const [data, setData] = useState();

  useEffect(() => {
    if (params.docId !== 'add') {
      Rb.get(`attachments/${params.docId}`)
        .then(r => deburrObject(r.data.data))
        .then(setData)
        .then(() => setStatus('success'))
        .catch(() => setStatus('error'));
    } else {
      setData({});
      setStatus('success');
    }
  }, []);

  if (status === 'success') {
    return (
      <AttachmentProvider>
        <PageTitle>Document</PageTitle>

        <Form data={{ ...data, ...params }} />
      </AttachmentProvider>
    );
  }

  return <PseudoStates status={status} />;
};

export default PatientsDocsDetails;
